import { createEffect, createSignal } from "solid-js";
import type { useLocation } from "@tanstack/solid-router";

export function useAppDialogs(location: ReturnType<typeof useLocation>) {
  const [isSidebarOpen, setIsSidebarOpen] = createSignal(false);
  const [shortcutsOpen, setShortcutsOpen] = createSignal(false);

  // Close the mobile sidebar whenever the route changes.
  createEffect(() => {
    void location().pathname;
    setIsSidebarOpen(false);
  });

  return {
    isSidebarOpen,
    setIsSidebarOpen,
    shortcutsOpen,
    setShortcutsOpen,
  };
}
